module.exports = __webpack_public_path__ + "img/mobile/BetBar/logo@2x.png?1.0.17";